const termsandconditions = { data: [], loading: true };

export const GetAllTermsAndConditionsRed = (state = termsandconditions, action) => {
  switch (action.type) {
    case "get_alltermsandconditions":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
